export const TAMANHO_PAGINA_LIBERACOES = 2;

export function totalPaginasLiberacao(total, tamanho = TAMANHO_PAGINA_LIBERACOES) {
  if (!total) return 1;
  return Math.max(1, Math.ceil(total / tamanho));
}

export function paginaAjustadaLiberacao(total, pagina, tamanho = TAMANHO_PAGINA_LIBERACOES) {
  const atual = Number(pagina) || 1;
  return Math.min(Math.max(atual, 1), totalPaginasLiberacao(total, tamanho));
}

export function recortarLiberacoes(lista, pagina, tamanho = TAMANHO_PAGINA_LIBERACOES) {
  const itens = lista || [];
  const atual = paginaAjustadaLiberacao(itens.length, pagina, tamanho);
  const inicio = (atual - 1) * tamanho;
  return itens.slice(inicio, inicio + tamanho);
}
